import { useToast } from '@chakra-ui/react';
import AdminPageShell from '../../../components/layout/AdminPageShell';
import React, { useEffect } from 'react';
import { getData, postData } from '../../../utils/httpClient.js';
import { useSearch } from '../../../contexts/SearchContext.js';
import CreateCreditNote from '../../../components/CreateInvoice/CreateCreditNote.js';

const openDocumentPdf = async (docId, toast) => {
  const response = await getData(`/invoices/document/${docId}`);
  const base64Data = response.payload.document.data;
  const mimeType = response.payload.document.mime_type || 'application/pdf';
  const byteCharacters = atob(base64Data);
  const byteNumbers = new Array(byteCharacters.length).fill(0).map((_, i) => byteCharacters.charCodeAt(i));
  const blob = new Blob([new Uint8Array(byteNumbers)], { type: mimeType });
  const blobUrl = URL.createObjectURL(blob);
  window.open(blobUrl, '_blank');
  setTimeout(() => URL.revokeObjectURL(blobUrl), 10000);
};

export default function CreateCreditNoteView() {
  const { resetListFilters } = useSearch();
  const toast = useToast();

  const handleSubmit = async (formData) => {
    try {
      const response = await postData('/invoices', formData);
      toast({
        title: 'Nota de crédito creada',
        description: 'Abriendo PDF...',
        status: 'success',
        duration: 3000,
        isClosable: true,
      });
      const docId = response?.payload?.invoice?.numero || response?.payload?.invoice?.id;
      if (docId) {
        try {
          await openDocumentPdf(docId, toast);
        } catch {
          toast({
            title: 'NC creada, no se pudo abrir el PDF',
            status: 'warning',
            duration: 4000,
            isClosable: true,
          });
        }
      }
    } catch (error) {
      toast({
        title: 'Error al crear nota de crédito',
        description: error.message || 'Hubo un error al crear la nota de crédito.',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    }
  };

  useEffect(() => {
    resetListFilters();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <AdminPageShell title="Crear nota de crédito">
      <CreateCreditNote onSubmit={handleSubmit} />
    </AdminPageShell>
  );
}
